new Swiper('.bm-hero-slider', {
    loop: true,

    pagination: {
        el: '.bm-pagination',
        clickable: true
    },

    autoplay: {
        delay: 5000
    }
});